export const subtractDay = (date: Date): Date => new Date(date.getTime() - 1000 * 60 * 60 * 24);

export const getThisQuarterStart = (currentMonth: number, currentYear: number): Date => {
  if (currentMonth < 4) {
    return new Date(`1/1/${currentYear}`);
  }

  if (currentMonth < 7) {
    return new Date(`4/1/${currentYear}`);
  }

  if (currentMonth < 10) {
    return new Date(`7/1/${currentYear}`);
  }
  return new Date(`10/1/${currentYear}`);
};

export const getThisQuarterEnd = (currentMonth: number, currentYear: number): Date => {
  if (currentMonth < 4) {
    return new Date(`3/31/${currentYear}`);
  }

  if (currentMonth < 7) {
    return new Date(`6/30/${currentYear}`);
  }

  if (currentMonth < 10) {
    return new Date(`9/30/${currentYear}`);
  }
  return new Date(`12/31/${currentYear}`);
};

export const getLastQuarterStart = (currentMonth: number, currentYear: number): Date => {
  if (currentMonth < 4) {
    return new Date(`10/1/${currentYear - 1}`);
  }

  if (currentMonth < 7) {
    return new Date(`1/1/${currentYear}`);
  }

  if (currentMonth < 10) {
    return new Date(`4/1/${currentYear}`);
  }
  return new Date(`7/1/${currentYear}`);
};

export const getLastQuarterEnd = (currentMonth: number, currentYear: number): Date => {
  if (currentMonth < 4) {
    return new Date(`12/31/${currentYear - 1}`);
  }

  if (currentMonth < 7) {
    return new Date(`3/31/${currentYear}`);
  }

  if (currentMonth < 10) {
    return new Date(`6/30/${currentYear}`);
  }
  return new Date(`9/30/${currentYear}`);
};
